import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { FadeIn } from "../components/FadeIn";

const ContactInfo = () => (
  <FadeIn className="lg:col-span-2">
    <p className="overline-label mb-4">Client Services</p>
    <h1 className="font-display text-4xl sm:text-5xl text-capra-ivory mb-6">Contact the Maison</h1>
    <p className="text-sm text-capra-muted leading-relaxed mb-10">
      For orders, private appointments, or care of your pieces — our client advisors respond within one business day.
    </p>
    <div className="space-y-6 text-sm">
      <div>
        <p className="overline-label mb-1.5">Email</p>
        <p className="text-capra-ivory">clientele@caprafalconeri.com</p>
      </div>
      <div>
        <p className="overline-label mb-1.5">Shipping &amp; Returns</p>
        <p className="text-capra-muted leading-relaxed">Complimentary insured shipping worldwide. Returns within 14 days, in original condition.</p>
      </div>
      <div>
        <p className="overline-label mb-1.5">Hours</p>
        <p className="text-capra-muted">Monday – Saturday, 9:00 – 19:00 CET</p>
      </div>
    </div>
  </FadeIn>
);

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Your message has reached the maison. We will reply shortly.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    }
    setBusy(false);
  };

  const inputCls =
    "w-full bg-capra-surface border border-white/10 px-4 py-3 text-sm text-capra-ivory placeholder:text-capra-muted/50 outline-none focus:border-capra-bronze transition-colors";

  return (
    <div className="pt-36 lg:pt-44 pb-24" data-testid="contact-page">
      <div className="px-6 lg:px-10 max-w-[1200px] mx-auto grid lg:grid-cols-5 gap-16">
        <ContactInfo />

        <FadeIn delay={0.1} className="lg:col-span-3">
          <form onSubmit={submit} className="leather-panel p-8 lg:p-12 space-y-5" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-5">
              <input data-testid="contact-name-input" required placeholder="Name" value={form.name} onChange={set("name")} className={inputCls} />
              <input data-testid="contact-email-input" required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={inputCls} />
            </div>
            <input data-testid="contact-subject-input" placeholder="Subject" value={form.subject} onChange={set("subject")} className={inputCls} />
            <textarea data-testid="contact-message-input" required rows={6} placeholder="Your message" value={form.message} onChange={set("message")} className={`${inputCls} resize-none`} />
            <button
              data-testid="contact-submit-button"
              disabled={busy}
              className="px-10 py-4 bg-capra-bronze text-capra-night text-[11px] uppercase tracking-[0.25em] font-semibold hover:bg-capra-amber transition-colors disabled:opacity-60"
            >
              {busy ? "Sending…" : "Send Message"}
            </button>
          </form>
        </FadeIn>
      </div>
    </div>
  );
}
